/*
 * @Author: zj 
 * @Date: 2019-04-17 14:14:08 
 * @Last Modified by: zj
 * @Last Modified time: 2019-04-17 15:52:44
 * flashcache功能
 * 具体实现 
 * put  指定 id 存在一份数据，可以为任何类型，以供其它逻辑获取使用
 * take  根据 id 获取数据，数据只能被存在一次，获取一次。如果只存放一次，第二次获取 会得到 null 。
 */

import Vuex from 'vuex'
const flashcache = new Vuex.Store({
    state:{},
})

const put = function (id,valus){

    if(flashcache.getters[id]!=undefined){
        return;
    }

    flashcache.state[id] = valus;
    
}

const take = function (id){

    var data = null;

    if(flashcache.state[id]!=undefined){
        if(flashcache.state[id]!=null){
            data = flashcache.state[id];
            flashcache.state[id] = null;
        }
    }

    return data;
}

export default {
    put,
    take
}


// WEBPACK FOOTER //
// ./src/communal/flashcache/index.js